import React from "react";
import { Tooltip } from "../Tooltip";
import aboutData from "../../data/about.json";

const LinkedInSocialLink = ({ iconClassName = "fab fa-linkedin-in" }) => (
  <li className="social-icons-linkedin">
    <Tooltip text="LinkedIn" placement="top">
      <a
        href={aboutData.linkedin_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className={iconClassName} />
      </a>
    </Tooltip>
  </li>
);

export default LinkedInSocialLink;
